<div class="agpr-formField agpr-imageUploadField">
    <div class="agpr-imageUploadFieldContainer">
        <div
            *ngIf="field.label"
            class="agpr-formField-label"
            [id]="id + '_imageUpload_label'"
        >
            <span>
                {{ field.label | localize }}
            </span>
            <span
                *ngIf="field.tooltip"
                role="img"
                class="fa-regular fa-circle-info agpr-imageUploadField-infoCircle"
                [agprTooltip]="field.tooltip"
            ></span>
        </div>
        <agpr-button
            *ngIf="field.buttonLabel"
            [label]="field.buttonLabel"
            [style]="buttonTypes.tertiary"
            class="agpr-imageUploadField-inputLabel"
            (click)="fileInput.click()"
            [ariaDescribedBy]="id + '_imageUpload_state'"
            [ariaLabelledBy]="id + '_imageUpload_label'"
        >
        </agpr-button>
        <button
            *ngIf="field.icon"
            class="agpr-imageUploadField-icon"
            [ngClass]="field.icon"
            [agprTooltip]="field.tooltip"
            tooltipPosition="top"
            [attr.aria-label]="field.tooltip | localize"
            (click)="fileInput.click()"
        >
        </button>
        <input
            #fileInput
            type="file"
            class="agpr-imageUploadField-input"
            [id]="id + '.imageUploadInput'"
            [accept]="field.accepts"
            (change)="handleFileInput($event.target.files[0], fileInput)"
            (click)="resetInputValue(fileInput)"
        />
    </div>
    <div [id]="id + '_imageUpload_state'" class="agpr-imageUploadField-imageUploadState">{{ field.imageUploadState | localize }}</div>
</div>
